var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4208_11345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7539 44.0625L53.6016 58.8984C55.0664 60.3633 57.4453 60.3633 58.9102 58.8984C60.375 57.4336 60.375 55.0547 58.9102 53.5898L44.0625 38.7539C42.5742 40.7812 40.7812 42.5742 38.7539 44.0625Z",
    fill: "#5B5E65"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.375 7.5C26.5911 7.5 28.7854 7.93648 30.8328 8.78453C32.8802 9.63258 34.7404 10.8756 36.3074 12.4426C37.8744 14.0096 39.1174 15.8698 39.9655 17.9172C40.8135 19.9646 41.25 22.1589 41.25 24.375C41.25 26.5911 40.8135 28.7854 39.9655 30.8328C39.1174 32.8802 37.8744 34.7404 36.3074 36.3074C34.7404 37.8744 32.8802 39.1174 30.8328 39.9655C28.7854 40.8135 26.5911 41.25 24.375 41.25C22.1589 41.25 19.9646 40.8135 17.9172 39.9655C15.8698 39.1174 14.0096 37.8744 12.4426 36.3074C10.8756 34.7404 9.63258 32.8802 8.78453 30.8328C7.93648 28.7854 7.5 26.5911 7.5 24.375C7.5 22.1589 7.93648 19.9646 8.78453 17.9172C9.63258 15.8698 10.8756 14.0096 12.4426 12.4426C14.0096 10.8756 15.8698 9.63258 17.9172 8.78453C19.9646 7.93648 22.1589 7.5 24.375 7.5ZM24.375 48.75C30.8397 48.75 37.0395 46.1819 41.6107 41.6107C46.1819 37.0395 48.75 30.8397 48.75 24.375C48.75 17.9103 46.1819 11.7105 41.6107 7.13927C37.0395 2.56807 30.8397 0 24.375 0C17.9103 0 11.7105 2.56807 7.13927 7.13927C2.56807 11.7105 0 17.9103 0 24.375C0 30.8397 2.56807 37.0395 7.13927 41.6107C11.7105 46.1819 17.9103 48.75 24.375 48.75Z",
    fill: "#5B5E65"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4208_11345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.69bdace818e359dc7854744620b0c59a.svg";
export { ForwardRef as ReactComponent };